import script from "./BaseReloadData.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseReloadData.vue?vue&type=script&setup=true&lang=ts"

import "./BaseReloadData.vue?vue&type=style&index=0&id=e552c834&lang=scss"

const __exports__ = script;

export default __exports__